import React from "react";

const Render = (props, context) => {
  var user = props.user;
  var position = props.position;
  var rank = props.rank;
  
  return (
    <li className="box borderBox" key={position.toString()} id={position}>
      <div className="pRel borderBox">
        <div className="body pal bodycontainer backgroundRankingCard round">
          <div className="escudo pRel mha fullWidth">
            <img
              src={`${
                user.avatar
                  ? user.avatar.icon
                  : "/avatars/escudo_vacio.png"
              }`}
              alt="Avatar del usuario."
              className="avatar displayBlock fullWidth mbl"
            />
            <p className="pAbs bgYellow avenirBK black gold">{position}</p>
          </div>
          <h2 className="mbl avenirBK white alignCenter">
            {user.name} {user.surname} 
          </h2>
        </div>
        <div className="horizontalCenter pam bold black gold">{rank}° a nivel nacional</div>
        <div className="footer bgGreyXXL verticalCenterFlex">
          <p className="cifra man avenirBK violet upperCase alignCenter">
            {user.points} <span className="avenirL"></span>
          </p>
          <p className="titulo mbn violet alignCenter">PUNTOS</p>
        </div>
      </div>
    </li>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Ranking/RankedUser.js